export default "__VITE_ASSET__28ba5e5a__"